import Axios from "axios";

const baseURL = process.env.VUE_APP_API_URL;
const axios = Axios.create({
  baseURL,
  headers: {},
  withCredentials: false
});

// если нужно добавлять в конфиг на лету для каждого запроса
/* axios.interceptors.request.use((config) => {
  return config;
}); */

export default axios;
